<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Saldos de la Cuenta">
          <!--
          <template slot="header">
            Datos del Proveedor
          </template>
          -->
          <b-table 
              small 
              responsive="sm" 
              :busy="tableBusy"
              :items="bancoCuentaSaldos" 
              :fields="campos">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
            <!--<i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>-->
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>      
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancocuenta/getField',
  mutationType: 'bancocuenta/updateField',
});

export default {
  name: 'BancoCuentaSaldos',
  components: {
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data: () => {
    return {
      id: 0,
      campos: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      loaded: false,
      tableBusy: false,
    }
  },
  created() {
    this.id= this.$route.params.id

    let params = {
      bancoCuentaId: this.id,
      fechaHasta: new Date()
    }

    this.tableBusy = true;
    this.$store.dispatch('bancocuenta/getSaldoBancoCuenta', params)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'bancoCuentaSaldos',
    ]),
  },  
  methods: {
    goBack() {
      this.$router.go(-1);
      /*this.$router.push({ name: 'BancosCuentas' });*/
    },
  }
}
</script>
